import { filesURL } from './auth';

/**
 * Returns the URL for a country flag SVG image
 * @param countryCode - The ISO 3166-1 alpha-2 country code (e.g. 'US', 'GB', 'FR')
 * @returns The full URL to the country flag SVG
 * @example
 * countryFlag('US') // returns "path/to/icons/country-flags/US.svg"
 */
export const countryFlag = (countryCode: string): string => {
  const normalizedCode = countryCode.toUpperCase();
  return `${filesURL}/icons/country-flags/${normalizedCode}.svg`;
};
